import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../app/data/root.store';
import { VaultDownIcon } from '../../assets/icons';
import { SORT_BY_OPTIONS } from '../../data/vault-store';
import { VaultSortDropdown } from '../VaultSortDropdown/VaultSortDropdown';
import { VaultMobileFileList } from './VaultMobileFileList';
import { VaultMobileHeader } from './VaultMobileHeader';
import {
    VaultMobileContainer,
    VaultMobileContent,
    VaultMobileListHeader,
    VaultMobileListHeaderSortButton,
    VaultMobileListHeaderSortDirectionButton
} from './VaultMobileList.styles';

export const VaultMobileList = observer(() => {
    const { vaultStore } = useStore();
    const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

    useEffect(() => {
        if (!vaultStore.files.length && !vaultStore.isLoading) {
            vaultStore.refetchFiles();
        }
    }, [vaultStore]);

    const handleSortDirectionClick = (e) => {
        e.stopPropagation();
        vaultStore.setSortDirection(-vaultStore.sortDirection);
    };

    return (
        <VaultMobileContainer>
            <VaultMobileHeader />

            {vaultStore.files.length > 0 && <VaultMobileListHeader>
                <div>{`Name (${vaultStore.mobileVisibleFiles})`}</div>
                <VaultMobileListHeaderSortButton onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}>
                    <div>{SORT_BY_OPTIONS[vaultStore.sortBy].label}</div>
                    <VaultMobileListHeaderSortDirectionButton
                        sortDirection={vaultStore.sortDirection}
                        onClick={handleSortDirectionClick}
                    >
                        <VaultDownIcon />
                    </VaultMobileListHeaderSortDirectionButton>
                </VaultMobileListHeaderSortButton>
                {isSortDropdownOpen && <VaultSortDropdown onClose={() => setIsSortDropdownOpen(false)} />}
            </VaultMobileListHeader>}

            <VaultMobileContent>
                <VaultMobileFileList />
            </VaultMobileContent>
        </VaultMobileContainer>
    );
}); 